(() => {
    frappe.ready(() => {
        const Orig = webshop.ProductList;
        if (!Orig) return;

        class ProductListPatched extends Orig {
            // Revert adj2: list view cart controls back to right-aligned
            // (original position before adj2). The price table + cart stay
            // on the same horizontal level in the bottom row (adj3).
            // No override needed — list.js base get_cart_action_row is
            // already right-aligned; we only need the bottom-row CSS to
            // revert for list view. The bulk prices move into the bottom row.

            // Item code + simple UOM view + UOM text on ONE line
            // (PIT-TASK-2027-000337). Mirrors the base get_title_html; the
            // plain item-code line is replaced by the shared code/UOM row.
            get_title_html(item, title, settings) {
                const item_link = webshop.get_item_link ? webshop.get_item_link(item, settings) : `/${ item.route || '#' }`;
                const title_html = item_link
                    ? `<a href="${ item_link }"
                            style="color: var(--gray-800); font-weight: 600; text-decoration: none;">
                            ${ title }
                        </a>`
                    : `<span style="color: var(--gray-800); font-weight: 600;">${ title }</span>`;
                // Item's custom_additional_1 under the item name (PIT-TASK-2027-000308)
                const additional_1_html = webshop.get_custom_additional_1_html
                    ? webshop.get_custom_additional_1_html(item, settings) : "";
                const code_row_html = webshop.get_item_code_row_html
                    ? webshop.get_item_code_row_html(item, settings) : "";
                return `
                    <div style="display: flex; align-items: center;">
                        <div style="flex: 1;">
                            ${ code_row_html }
                            ${ title_html }
                            ${ additional_1_html }
                        </div>
                    </div>
                `;
            }

            get_item_details(item, settings) {
                let details = '';
                if (settings.custom_show_item_group) {
                    details += `
                    <div class="product-category" itemprop="name">
                        ${ item.item_group_display || item.item_group }
                    </div>
                `;
                }

                // Standard price display: keep the price here in the
                // details area (not in the bottom row — the list row is
                // wider, the price sits above the bulk prices as before).
                // Sold Out (PIT-TASK-2027-000358 adjustment 1): no price at
                // all (no Einzelpreis, no struck MRP) for a sold-out item.
                if (item.formatted_price && !item.custom_sold_out) {
                    details += `
                    <div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
                        ${ item.formatted_price || '' }
                `;

                    if (item.formatted_mrp) {
                        details += `
                        <small class="striked-price">
                            <s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
                        </small>
                    `;
                    }

                    details += this.get_stock_availability(item, settings);
                    details += `</div>`;
                } else {
                    details += this.get_stock_availability(item, settings);
                }

                return details;
            }

            // Bottom row: cart controls (right) + bulk prices (left) + desc
            // (adj3 — bulk prices on the same horizontal level as the cart)
            get_bottom_row_html(item, settings) {
                const cart_row = this.get_cart_action_row(item, settings);
                const desc = item.short_description
                    ? `<div class="ws-short-desc">${ item.short_description }</div>` : ``;

                // Bulk prices move into the bottom row (adj3); hidden for
                // sold-out items (PIT-TASK-2027-000358 adjustment 1).
                const bulk_html = item.custom_sold_out ? "" : (item["bulk_prices_html"] || "");
                const bulk_wrapper = bulk_html ? `<div class="bulk-prices-wrapper">${bulk_html}</div>` : '';

                if (!desc && !cart_row && !bulk_wrapper) return ``;
                return `<div class="ws-bottom-row">${ bulk_wrapper }${ desc }${ cart_row }</div>`;
            }
        }
        webshop.ProductList = ProductListPatched;
    });
})();
